import { $win, $body, $doc } from "../utils/globals";

$win.on('load', function() {
  $body.addClass('is-loaded');
})

